export type ZipMembershipSourceModule = "Adequacy" | "NetworkIntegrity";

let _lastVisitedModule: ZipMembershipSourceModule | undefined;

export const getLastVisitedZipModule = (): ZipMembershipSourceModule | undefined => _lastVisitedModule;

export const setLastVisitedZipModule = (value: ZipMembershipSourceModule | undefined): void => {
  _lastVisitedModule = value;
};
